import { useCallback } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import useCarInfo from 'app/hook/hs/useCarInfo';
import useEnlog from 'app/hook/common/useEnlog';
import dayjs from 'app/libs/dayjs';

export default function useEnlogHs() {
	const { enloggingJsonData } = useEnlog();
	const { car } = useCarInfo();

	const { carId } = useParams();
	const { search } = useLocation();
	const {
		ew: ewYn,
		extendedWarrantyMonth: ewPeriod,
		login: loginYn,
		payment,
		loanVersion,
		carId: paramCarId,
		applicationId,
		customerLeadApplicationId,
		encarpay: encarpayyn,
		safecar,
		from_click,
		isHsReapply,
	} = queryString.parse(search);
	const normalizedPayment = payment === 'ENCAR_PAY' && loanVersion === 'V2' ? 'FREE_INTEREST' : payment;

	const { carNo, modelGroupNm, modelNm } = car;

	const dtView = useCallback(
		(data = {}) => {
			const { firstPaymentMethod } = data;
			const dataTalkView = {
				screenname: data.screenname,
				...(data.eventnamegroup ? { eventnamegroup: data.eventnamegroup } : {}),
				param: {
					...data.param,
					...(ewYn && { ewYn }),
					...(ewPeriod && { ewPeriod }),
					...(loginYn && { loginYn }),
					...((customerLeadApplicationId || applicationId) && { applicationId: customerLeadApplicationId || applicationId }),
					...(encarpayyn && { encarpayyn }),
					...(from_click && { from_click }),
					...(safecar && { safecar }),
					...((firstPaymentMethod || normalizedPayment) && { payment: firstPaymentMethod || normalizedPayment }),
					carId: carId || paramCarId || '',
					process: '신청',
					status: 'WAIT_CONSULTATION', // 홈서비스 진행단계가 상담대기중 상태에서만 한도조회가능
					...(isHsReapply === 'Y' && { attributes: 'retry' }),
				},
			};
			const braze = {
				customEvent: {
					name: 'hs_complete',
					param: {
						carNo: carNo ? `${carNo?.slice(-4)}` : 'undefined',
						carID: `${carId}`,
						model: `${modelGroupNm}`,
						trim: `${modelNm}`,
					},
				},
				customAttribute: {
					name: '홈서비스 신청 이력',
					param: [
						`date_${dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')}`,
						`carNo_${carNo ? `${carNo?.slice(-4)}` : 'undefined'}/${modelGroupNm}/${modelNm}`,
						`carID_${carId}`,
					],
				},
			};

			enloggingJsonData({
				dataTalkView,
				...(data.screenname === '홈서비스신청_완료' && { braze }),
			});
		},
		[
			ewYn,
			ewPeriod,
			loginYn,
			applicationId,
			customerLeadApplicationId,
			encarpayyn,
			from_click,
			safecar,
			carId,
			paramCarId,
			isHsReapply,
			carNo,
			modelGroupNm,
			modelNm,
			enloggingJsonData,
			normalizedPayment,
		],
	);

	return {
		dtView,
		enloggingJsonData,
	};
}
